import whatsappButton from "@/assets/whatsapp-button.png";

const WHATSAPP_NUMBER = "27123456789"; // Replace with actual number
const WHATSAPP_MESSAGE = "Hi, I'm interested in corporate car wash services for my business.";

export const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener"
      className="fixed bottom-6 right-6 z-50 hover:scale-105 transition-transform duration-300"
      aria-label="Chat on WhatsApp"
    >
      <img 
        src={whatsappButton} 
        alt="WhatsApp - Click to chat" 
        className="h-12 md:h-14 w-auto"
      />
    </a>
  );
};

export const getWhatsAppUrl = () => {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
};
